import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { RolesService } from '../../core/services/roles/roles.service';
import { Subject } from 'rxjs';
import { NgStyle } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AssetsTableComponent } from './components/assets-table/assets-table.component';
import { UploadAssetComponent } from './components/upload-asset/upload-asset.component';

@Component({
    selector: 'app-assets-library',
    templateUrl: './assets-library.component.html',
    styleUrls: ['./assets-library.component.scss'],
    imports: [NgStyle, ReactiveFormsModule, FormsModule, AssetsTableComponent, UploadAssetComponent]
})
export class AssetsLibraryComponent implements OnInit {
  searchValue = '';
  assetsStatus = 'loading';
  canSelect = false;
  canEdit = true;
  showUploadModal: Boolean = false;
  scrollSubject: Subject<any> = new Subject<any>();

  @ViewChild('fileUpload') fileUpload: ElementRef;

  constructor(private rolesService: RolesService) {}

  ngOnInit() {}

  checkAssets(data) {
    this.assetsStatus = data;
  }

  uploadNewAsset(e: Event) {
    e.stopPropagation();
    this.showUploadModal = true;
  }

  canEditAssets() {
    return this.rolesService.canEditAssets();
  }

  cancelUpload() {
    this.showUploadModal = false;
  }

  finishUpload() {
    this.assetsStatus = 'updated';
  }
}
